import { render, staticRenderFns } from "./documentHeader.vue?vue&type=template&id=0f6f3ff6&scoped=true&"
import script from "./documentHeader.vue?vue&type=script&lang=js&"
export * from "./documentHeader.vue?vue&type=script&lang=js&"
import style0 from "./documentHeader.vue?vue&type=style&index=0&id=0f6f3ff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6f3ff6",
  null
  
)

export default component.exports